import Button from '@Components/Buttons/Button'
import FilesPreview from '@Components/DocumentUploadForm/FilesPreview'
import { UPLOAD_OC_DOC_DESCRIPTION_HELP_TEXT } from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDocumentUploadForm'
import { UnifiedDocument } from '@Entities/document/document-to-upload'
import React, { RefObject } from 'react'

interface SelectedDocumentsPanelProps {
    browseFilePickerRef: RefObject<HTMLInputElement | null>
    isUploading: boolean
    onDescriptionChange?: (document: UnifiedDocument, description: string, index: number) => void
    onRemove: (document: UnifiedDocument, index: number) => void
    onSubmit: () => void
    uploadedFiles: UnifiedDocument[]
}

const SelectedDocumentsPanel = ({
    browseFilePickerRef,
    isUploading,
    onDescriptionChange,
    onRemove,
    onSubmit,
    uploadedFiles,
}: SelectedDocumentsPanelProps) => {
    const hasSelectedDocuments = uploadedFiles.length > 0

    return (
        <div className="selected-documents-column">
            {hasSelectedDocuments ? (
                <h4>Your Selected Documents ({uploadedFiles.length})</h4>
            ) : (
                <div className="selected-documents-empty-state">
                    <strong>Nothing selected yet</strong>
                    <p>
                        Browse or drag and drop files, search for existing documents, or choose from your recently used
                        files below. Your selected documents will be displayed here.
                    </p>
                </div>
            )}
            <FilesPreview
                uploadedFiles={uploadedFiles}
                filesWereUploaded={false}
                onRemove={onRemove}
                onDescriptionChange={onDescriptionChange}
                descriptionHelpText={UPLOAD_OC_DOC_DESCRIPTION_HELP_TEXT}
                browseFilePickerRef={browseFilePickerRef}
                hideConfirmationText
                emptyState={<></>}
            />
            {hasSelectedDocuments && (
                <Button
                    mainColor
                    type="primary"
                    className="submit-documents-button"
                    disabled={isUploading}
                    onClick={onSubmit}
                >
                    Submit Documents
                </Button>
            )}
        </div>
    )
}

export default SelectedDocumentsPanel
